<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand navbar-dark bg-dark py-2 border-bottom sticky-top bg-success DSAD navbar-dark"
    type="">
    <!-- Navbar left -->
    <div class="nav-menu">
      <ul class="navbar-nav mdc-toolbar">
        <li class="nav-item">
          <a 
            href="#" 
            class="mdc-toolbar__icon d-flex align-items-center justify-content-between">
            <div class="mdc-toolbar__per align-middle">
              <span>75</span>
              <div class="mdc-toolbar__slice">
                <div class="mdc-toolbar__bar"/>
                <div class="mdc-toolbar__fill"/>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <!-- Navbar brand logo -->
    <div class="navbar-brand mx-auto">
      <a 
        href="#" 
        class="navbar-brand mr-0">
        <img 
          src="@/assets/img/brand/logo.svg" 
          alt="">
      </a>
    </div>
    <!-- Navbar right -->
    <div class="nav-menu">
      <div class="ml-auto">
        <div class="d-flex">
          <!-- Search form -->
          <!-- <form 
            id="navbar-search-main" 
            class="navbar-search navbar-search-light form-inline mr-lg-5">
            <div class="form-group mb-0">
              <div class="input-group input-group-alternative input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-search"/></span>
                </div>
                <input 
                  class="form-control" 
                  placeholder="Search" 
                  type="text">
              </div>
            </div>
            <button 
              type="button" 
              class="close" 
              data-action="search-close" 
              data-target="#navbar-search-main" 
              aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </form> -->
          <ul class="navbar-nav align-items-center ">
            <!-- <li class="nav-item mr-1">
              <a 
                href="#" 
                class="nav-link py-1 px-2" 
                data-action="search-show" 
                data-target="#navbar-search-main">
                <span class="btn-inner--icon text-lg text-sm"><i class="fas fa-search"/></span>
              </a>
            </li>
            <li class="nav-item mr-1 d-none">
              <a 
                href="#" 
                class="nav-link py-1 px-2">
                <span class="btn-inner--icon text-lg text-md"><i class="fas fa-expand-arrows-alt"/></span>
              </a>
            </li>
            <li class="nav-item dropdown d-md-block">
              <a 
                href="#" 
                class="nav-link py-1 px-2" 
                data-toggle="tooltip" 
                data-original-title="View detailed log" 
                data-target="offcanvasLog" 
                data-offcanvasfrom="offcanvas">
                <span class="btn-inner--icon text-lg text-sm"><i class="ni ni-atom"/></span>
              </a>
            </li> -->
            <li class="nav-item dropdown ml-2 ml-md-3">
               <base-button 
                class="borderRadius-25" 
                type="success"
                @click="$emit('headerLoginClicked')"
                >
                <span class="btn-min-sm">Sign in</span>
              </base-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </base-nav>
</template>
<script>
import { BaseNav } from '@/components';
export default {
components: {
    BaseNav
},
data() {
    return {
    
    };
},
computed: {
    
},
methods: {

}
};
</script>
<style lang="scss" scoped>
  @import "~assets/sass/base/core/navbar/navbar";
</style>
